import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonTypesEnum } from '../../enums/button-types.enum';
import { AiGeneratedContentModel } from '../../models/ai-generated-content-card.model';


@Component({
    selector: 'agpr-ai-generated-content-card',
    templateUrl: './ai-generated-content-card.component.html',
    styleUrls: ['./ai-generated-content-card.component.scss'],
    standalone: false
})
export class AiGeneratedContentCardComponent  {
    readonly buttonTypes = ButtonTypesEnum;
    readonly MAX_HISTORY = 100;

    @Input() contentElement: AiGeneratedContentModel;
    @Input() disabled: boolean;
    @Output() regenerateClicked = new EventEmitter<string>();

    prev(): void {
        if (this.disabled || this.contentElement.currentIndex <= 0) {
            return;
        }

        this.contentElement.currentIndex --;
        this.contentElement.value = this.contentElement.history[this.contentElement.currentIndex];
    }

    next(): void {
        if (this.disabled || this.contentElement.currentIndex >= this.contentElement.history?.length - 1) {
            return;
        }

        this.contentElement.currentIndex ++;
        this.contentElement.value = this.contentElement.history[this.contentElement.currentIndex];
    }

    regenerate(): void {
        if (this.disabled) {
            return;
        }

        this.contentElement.value = '';
        this.contentElement.loading = true;
        this.regenerateClicked.next(this.contentElement.id);
    }
}
